import {handleValidationChange} from '../CommonValidation';

export const validateHoliday = (data, setIsError) => {
    var isValid = true;

    if(data.name === "" || data.name === undefined) {
        handleValidationChange("name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("name", false, setIsError);
    }

    if(data.date === "" || data.date === undefined) {
        handleValidationChange("date", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("date", false, setIsError);
    }

    // if(data.addon_rate === "" || data.addon_rate === undefined) {
    //     handleValidationChange("addon_rate", true, setIsError);
    //     isValid=false;
    // } else {
    //     handleValidationChange("addon_rate", false, setIsError);
    // }

    if(data.type === "" || data.type === undefined) {
        handleValidationChange("type", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("type", false, setIsError);
    }

    return isValid
  
}
